/* eslint-disable no-console */
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
import { useSidePopout } from 'modules/layout';
import {
  BodyText,
  ButtonType,
  HeadlineTitle,
  InputWithLabel,
} from 'modules/ui';
import { FormButtons, FormContainer } from 'modules/ui/form';
import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import { useToastContainer } from 'modules/layout/toastContainer';
import { ToastType } from 'modules/ui/toast';
import { LoginForm } from '../../login';
import { FooterButtons } from './FooterButtons';
import { StyledBackButton } from './styled';
import { LoginSelectors, LoginThunks } from '../../login/redux';
import { resetError } from '../../login/redux/slice';

export const ForgottenPasswordForm: React.FC = () => {
  const { t } = useTranslation();
  const { changePopoutContainer } = useSidePopout();
  const dispatch = useAppDispatch();
  const { addToast } = useToastContainer();

  const [username, setUsername] = useState('');

  const forgottenPasswordError = useAppSelector(
    LoginSelectors.selectForgottenPasswordError,
  );
  const forgottenPasswordSuccess = useAppSelector(
    LoginSelectors.selectForgottenPasswordSuccess,
  );

  const handleForgottenPassword = useCallback(
    (event: any) => {
      event.preventDefault();
      dispatch(LoginThunks.forgottenPassword(username));
    },
    [dispatch, username],
  );

  useEffect(() => {
    if (forgottenPasswordError) {
      addToast({
        title: t('landingPage.forgottenPasswordForm.errorTitle'),
        text: t('landingPage.forgottenPasswordForm.errorMessage'),
        type: ToastType.Urgent,
      });
    } else if (forgottenPasswordSuccess) {
      addToast({
        title: t('landingPage.forgottenPasswordForm.successTitle'),
        text: t('landingPage.forgottenPasswordForm.successMessage'),
      });
    }
  }, [addToast, forgottenPasswordError, forgottenPasswordSuccess, t]);

  useEffect(
    () => () => {
      dispatch(resetError());
    },
    [dispatch],
  );

  return (
    <>
      <StyledBackButton
        type={ButtonType.SecondaryAction}
        text={t('landingPage.forgottenPasswordForm.backToLogin')}
        onClick={() =>
          changePopoutContainer({
            newContainer: <LoginForm />,
            urlKey: 'login',
          })
        }
      />
      <FormContainer noValidate onSubmit={handleForgottenPassword}>
        <HeadlineTitle>
          {t('landingPage.forgottenPasswordForm.forgottenPassword')}
        </HeadlineTitle>
        <BodyText>
          {t('landingPage.forgottenPasswordForm.instructionText')}
        </BodyText>

        <InputWithLabel
          label={t('landingPage.forgottenPasswordForm.username')}
          placeholderText={t(
            'landingPage.forgottenPasswordForm.usernamePlaceholder',
          )}
          onBlur={(e) => setUsername(e.target.value)}
        />

        <FormButtons
          text={t('landingPage.forgottenPasswordForm.sendRequest')}
          centered
        />

        <FooterButtons />
      </FormContainer>
    </>
  );
};
